import React from "react";
import PropTypes from "prop-types";

const Radio = ({
  name,
  value,
  checked,
  onChange,
  label,
  fieldsName,
  isErrorStatus,
  disabled,
  index,
  ...props
}) => (
  <div
    className={`radio-web-sdk ${isErrorStatus ? "error-state" : ""}`}
    data-testid={`radio-${name}`}
  >
    <input
      {...props}
      type='radio'
      id={`radio-input-${fieldsName}-${index}`}
      disabled={disabled}
      value={value}
      checked={checked}
      name={fieldsName}
      onChange={onChange}
      data-testid={`radio-input-${name}`}
      aria-label={!label ? " " : null}
    />
    <span />
    <label
      htmlFor={`radio-input-${fieldsName}-${index}`}
      disabled={disabled}
      data-testid={`radio-label-${name}`}
    >
      {label}
    </label>
  </div>
);

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  fieldsName: PropTypes.string,
  isErrorStatus: PropTypes.bool,
  disabled: PropTypes.bool,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Radio.defaultProps = {
  label: "",
  fieldsName: ""
};

export default Radio;
